export default React.createContext({
  currentRecipe: 0,
  changeRecipe: id => {}
});
